module.exports = __webpack_public_path__ + "img/vignette-ges.487a9210.jpg";